import { NgModule } from '@angular/core';
import { RouterModule, Routes, ExtraOptions } from '@angular/router';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { CookiePolicyComponent } from './pages/cookie-policy/cookie-policy.component';
import { HomeComponent } from './features/home/home.component';
import { ProfileComponent } from './features/profile/profile.component';
import { TermsAndConditionsComponent } from './pages/terms-and-conditions/terms-and-conditions.component';
import { ContactUsComponent } from './features/contact-us/contact-us.component';
import { RulesComponent } from './pages/rules/rules.component';
import { CompleteForgotPasswordComponent } from './features/complete-forgot-password/complete-forgot-password.component';
import { EmailChangedComponent } from './pages/email-changed/email-changed.component';
import { AccountActivatedComponent } from './pages/account-activated/account-activated.component';
import { WizardComponent } from './features/wizard/wizard.component';
import { PurchaseConfirmedComponent } from './pages/purchase-confirmed/purchase-confirmed.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { SeedComponent } from './features/seed/seed.component';


const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'cookie-policy', component: CookiePolicyComponent },
  { path: 'profile', component: ProfileComponent },
  { path: 'terms-and-conditions', component: TermsAndConditionsComponent },
  { path: 'contact-us', component: ContactUsComponent },
  { path: 'rules', component: RulesComponent },
  { path: 'reset-password', component: CompleteForgotPasswordComponent },
  { path: 'account-activated', component: AccountActivatedComponent },
  { path: 'email-changed', component: EmailChangedComponent },
  { path: 'purchase', component: WizardComponent },
  { path: 'purchase-confirmed', component: PurchaseConfirmedComponent },
  { path: 'seed', component: SeedComponent },
  { path: '404', component: NotFoundComponent },

  //lasciare sempre al fondo
  { path: '**', redirectTo: '/404', pathMatch: 'full' }
];

const routerOptions: ExtraOptions = {
  scrollPositionRestoration: 'enabled',
  anchorScrolling: 'enabled',
};

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
